import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import { SessionContext } from "../context/session-context";
import { UserContext } from "../context/user-context";

// Start Openlayers imports
import { Map, View } from 'ol';
import { Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import { Vector as VectorSource, OSM as OSMSource, TileImage} from 'ol/source';

import {Fill, Stroke, Style, Circle, Text} from 'ol/style';

import WKT from 'ol/format/WKT';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import Point from 'ol/geom/Point';
import MultiPoint from 'ol/geom/MultiPoint';
import {fromExtent} from 'ol/geom/Polygon';
import {boundingExtent} from 'ol/extent';

import Icon from 'ol/style/Icon';
import { unByKey } from "ol/Observable";

import { Projection} from 'ol/proj'
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';

import MousePosition from 'ol/control/MousePosition';
import {format} from 'ol/coordinate';
import {createBox} from 'ol/interaction/Draw';
import {
    defaults,
    Draw,
    Modify,
    Snap,
    Select,
    Translate,
    DragPan,
    MouseWheelZoom,
    Extent,
    DoubleClickZoom
} from 'ol/interaction';
import {altKeyOnly, click} from 'ol/events/condition';

import "ol/ol.css";

import BaseLayers from '../functions/BaseLayers';
import DataLayers from '../functions/DataLayers';
import getMapScale from '../functions/getMapScale';
import setMapScale from '../functions/setMapScale';
import getGeomFromCoords from '../functions/getGeomFromCoords';
import getInfoFromCoords from '../functions/getLayerItemInformation';
import getPrintWindowExt from "../functions/getPrintWindowExtent";
import recordView from "../functions/recordView";
import layerScaleCheck from "../functions/checkMapLayerDisplay";
import { CollectionsTwoTone } from '@material-ui/icons';


const bkgroundImg = require('../assets/LargeWatermark.png');

  export default function useMapping(props) {


    const useStyles = makeStyles({
        root: {
            flexGrow: 1,
            background: 'white',
            color: 'white',
            '& .ol-control button':{
                backgroundColor: '#0C4C35',
            },
            '& .ol-control button:hover':{
                backgroundColor: '#63D764',
            }
          },
        mapstyle: {
            width: props.width,
            height: props.height-30,
            /* minWidth:1130, */
            minHeight:400,
            background: `url(${bkgroundImg})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundColor: '#EBEBED',
        },

        copyrightLabel:{
            position:'fixed',
            height: 16,
            width: 400,
            bottom: 60,
            fontSize:12,
            left: props.left+(props.width/2)-90,
            //left: 'calc((100% / 2) - 90px)',
            color: '#000',
            zIndex:120,
        }

      });



    const classes = useStyles(props);
    const [sState, sDispatch] = useContext(SessionContext);
    const [uState] = useContext(UserContext);
    const [mapObj, setMapObj] = useState(null);
    const [print, setPrint] = useState(null);
    const [firstLoad, setFirstLoad] = useState(true);
    const [scale, setScale] = useState(10000);
    const [bLayer, setBLayer] = useState(null);
    const [currentView, setCurrentView] = useState([]);
    const [currentBLayer, setCurrentBLayer] = useState(null);
    const [currentextent, setCurrentextent] = useState([]);
    const [mapextent, setMapextent] = useState([]);
    const [mapPinLayer, setMapPinLayer] = useState(null);
    const [hasPin, setHasPin] = useState(false);

    const [displayPrintFrame, setDisplayPrintFrame] = useState(false);
    const [hasPrintWindow, setHasPrintWindow] = useState(false);
    const [printWindowLoaded, setPrintWindowLoaded] = useState(false);
    const [printWindowLayer, setPrintWindowLayer] = useState(null);
    const [printFrame, setPrintFrame] = useState(null);

    const [displayDataFrame, setDisplayDataFrame] = useState(false);
    const [hasDataWindow, setHasDataWindow] = useState(false);
    const [dataWindowLayer, setDataWindowLayer] = useState(null);

    const [hasReportWindow, setHasReportWindow] = useState(false);
    const [reportWindowLayer, setReportWindowLayer] = useState(null);

    const [annotationLayer, setAnnotationLayer] = useState(null);
    const [annotationUnits, setAnnotationUnits] = useState({});
    const [annotationArea, setAnnotationArea] = useState(0);
    const [annotationLength, setAnnotationLength] = useState(0);
    const [hasAnnotationLayer, setHasAnnotationLayer] = useState(false);

    const [measurementLayer, setMeasurementLayer] = useState(null);
    const [hasMeasurementLayer, setHasMeasurementLayer] = useState(false);

    const [hasWatermarkLayer, setHasWatermarkLayer] = useState(false);
    const [watermarkLayer, setWatermarkLayer] = useState(null);
    const [copyrightNotice, setCopyrightNotice] = useState(process.env.REACT_APP_OS_SCREENCOPY.replace("dddd", new Date().getFullYear()));

    const [viewScale, setViewScale] = useState(10000);
    

    //map interactions
    const [mapSelect, setMapSelect] = useState(null);
    const [mapDraw, setMapDraw] = useState(null);
    const [mapTranslate, setMapTranslate] = useState(null);
    const [mapSnap, setMapSnap] = useState(null);
    const [mapModify, setMapModify] = useState(null);
    const [mapWheelZoom, setMapWheelZoom] = useState(null);
    const [mapPan, setMapPan] = useState(null);
    const [clickListerner, setClickListerner] = useState(null);

    const [strokeColour, setStrokeColour] = useState('');
    const [strokeWidth, setStrokeWidth] = useState('');

    const [fillGeom, setFillGeom] = useState('');
    const [doUnion, setDoUnion] = useState(false);
    const [clickCoords, setClickCoords] = useState([]);
    const [fillToolActive, setFillToolActive] = useState(false);
    const [layerInfoActive, setLayerInfoActive] = useState(false);
    
    /**
     * Handles user actions the effect the map object
     */
    useEffect(() => {

        switch(sState.caction){
            case "endtools":
                clearAction();
            break;
            case "print":
                clearDataWindow();
                endReportWindow();
                clearAction();
                storeAnnotationLayer();
            break;
            case "endprint":
                endPrintWindow();
                clearAction();
            break;
            case "displaylayers":
                endPrintWindow();
                endReportWindow();
                clearAction();
                storeAnnotationLayer();
            break;
            case "export":
                endPrintWindow();
                endReportWindow();
                clearAction();
                storeAnnotationLayer();
            break;
            case "endexport":
                clearDataWindow();
                clearAction();
            break;
            case "createXYPolygon":
                clearSelectedAnnotations();
                clearAction();
                endReportWindow();
                endPrintWindow();
                drawDataRectangle(sState.requestdatageom.x, sState.requestdatageom.y);
            break;
            case "createCoordPolygon":
                clearSelectedAnnotations();
                clearAction();
                endReportWindow();
                endPrintWindow();
                drawDataCoords(sState.requestdatageom.minX, sState.requestdatageom.minY, sState.requestdatageom.maxX, sState.requestdatageom.maxY);
            break;
            case "createCustomDataPolygon":
                clearSelectedAnnotations();
                clearAction();
                endReportWindow();
                endPrintWindow();
                drawCustomDataPolygon();
            break;
            case "createCustomDataRectangle":
                clearSelectedAnnotations();
                clearAction();
                endReportWindow();
                endPrintWindow();
                drawCustomDataRectangle();
            break;
            case "endCustomDataDraw":
                resetMapInteractions();
            break;
            case "createXYReportPolygon":
                endReportWindow();
                endPrintWindow();
                clearDataWindow();
                drawReportRectangle(sState.requestreportgeom.x, sState.requestreportgeom.y);
            break;
            case "editDataPolygon":
                //clearAction();
                startDataEditMode();
            break;
            case "endEditDataPolygon":
                
                //clearAction();
                //startDataWindow();
            break;
            case "clearData":
                clearSelectedAnnotations();
                clearDataWindow();
            break;
            case "clearPrint":
                clearSelectedAnnotations();
                endPrintWindow();
            break;
            case "clearReport":
                clearSelectedAnnotations();
                endReportWindow();
            break;
            case "selectAnnotationObject":
                clearSelectedAnnotations();
                clearAction();
                selectAnnotationObject();
                clearFillPolygon();
            break;
            case "createAnnotationPolygon":
                clearSelectedAnnotations();
                clearAction();
                drawAnnotationPolygon();
                clearFillPolygon();
            break;
            case "createAnnotationText":
                clearSelectedAnnotations();
                clearAction();
                drawAnnotationText();
                clearFillPolygon();
            break;
            case "createAnnotationFill":
                clearSelectedAnnotations();
                clearAction();
                const listernKey = mapObj.on('singleclick', mapClickEvent);
                setClickListerner(listernKey);
                setFillToolActive(true);
            break;
            case "endAnnotationFill":
                clearFillPolygon();
            break;
            case "deleteAnnotation":
                clearAction();
                removeAnnotation();
            break;
            case "createMeasureLine":
                clearAction();
                drawMeasureLine();
            break;
            case "createMeasureArea":
                clearAction();
                drawMeasureArea();
            break;
            case "doInfoQuery":
                clearAction();
                const listernInfoKey = mapObj.on('singleclick', mapClickEvent);
                setClickListerner(listernInfoKey);
                setLayerInfoActive(true);
            break;
            case "endInfoQuery":
                clearAction();
                unByKey(clickListerner);
                setClickListerner(null)
                setLayerInfoActive(false);
            break;
            case "addressSearch":
            case "creditReached":
                clearDataWindow();
                endPrintWindow();
                endReportWindow();
                clearAction();
            break;
            case "logout":
                endPrintWindow();
                endReportWindow();
                clearDataWindow();
                removeAllAnnotation();
                removeDataLayers();
                clearAction();
            break;
            default:
            break;

        }
        
    },[sState.caction]);

    const clearAction = () => {

        resetMapInteractions();
        clearFillPolygon();
        sDispatch({
            type: "setUserAction",
            payload: { action: 'none'}
        });
    }

    const clearSelectedAnnotations = () => {

        if (hasAnnotationLayer){
            //const features = annotationLayer.getSource().getFeatures();
            const features = annotationLayer.getSource().getFeatures();
            for (let i = 0; i < features.length; i++) {
                const cStyle = features[i].getStyle();
                let selectStyle = [];
                if (features[i].get('shape') === 'polygon'){
                    selectStyle = [
                        new Style({
                            fill: new Fill({color: cStyle[0].fill_.color_}),
                            stroke: new Stroke({color: cStyle[0].stroke_.color_, width: cStyle[0].stroke_.width_}),
                        }),
                    ];
                }
                if (features[i].get('shape') === 'text'){
                    selectStyle = [
                        new Style({
                            fill: new Fill({color: cStyle[0].fill_.color_}),
                            stroke: new Stroke({color: cStyle[0].stroke_.color_, width: cStyle[0].stroke_.width_}),
                            text: new Text({text:cStyle[0].text_.text_, font:cStyle[0].text_.font_})
                        }),
                    ];
                }
                features[i].setStyle(selectStyle);
                //features.clear();
            }

            mapObj.render();

        }
    }


    const clearFillPolygon = () => {
        unByKey(clickListerner);
        setClickListerner(null);
        setFillToolActive(false);
    }
    
    const handleKeyPress = (e) => {

        if (!e.repeat){
            if ( e.key === 'Control'){ setDoUnion(true); }
        }
        
    }

    const handleKeyUp = (e) => {
        if ( e.key === 'Control'){ setDoUnion(false); }
    }
    
    const removeDataLayers = () => {
        mapObj.getLayers().forEach(layer => {
            if (layer.get('name') !== 'basemap' && layer.get('name') !== 'watermark') { 
                mapObj.removeLayer(layer);
            }
        });
    }

    /**
     * Function for polygon fill.
     */
    const mapClickEvent = (evt) => {
        const coords = String(mapObj.getCoordinateFromPixel(evt.pixel));
        const coordArray = coords.split(",");

        setClickCoords(coordArray);
    };

    /**
     * Listern event for map clicks.
     */
    useEffect(() => {

        if (fillToolActive){
            getGeomFromCoords(parseInt(clickCoords[0]), parseInt(clickCoords[1]), doUnion,fillGeom, sDispatch);
        }
        if (layerInfoActive){

            let layers = '';
            mapObj.getLayers().forEach(layer => {
                if (layers !== '') {layers +="," }
                layers += layer.get('name');
            });

            getInfoFromCoords(parseInt(clickCoords[0]), parseInt(clickCoords[1]), layers, sDispatch);
        }
    },[clickCoords]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        window.addEventListener('keyup', handleKeyUp);

        if (firstLoad){
            //This is the mapping component.
            let map = new Map({ target: null, layers: null, view: null});
            setTimeout(function() { //Implements a delay to draw map.

                proj4.defs('EPSG:27700', "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +datum=OSGB36 +units=m +no_defs"); 
                register(proj4);
        
                const osgb = new Projection({
                    code: 'EPSG:27700',
                    extent: [0, 0, 1400000, 1600000]
                });
                const view = new View({projection: osgb, center: [525651, 168117],zoom: 11 });
                map.setTarget('map');

                const mp = new MousePosition({
                    className: 'custom-mouse-position',
                    coordinateFormat: function(coordinate) {
                        return format(coordinate, 'BNG Ref: {x}, {y} Metres', 0);
                    }
                });
                mp.setTarget(document.getElementById('map_coordinates'));
                map.addControl(mp);
                //Populate the layers to display.
                const baselayer = BaseLayers(sState.blayer, uState.company.companytype);
                setCurrentBLayer(baselayer);
                //map.addLayer(baselayer);
                map.getLayers().insertAt(0, baselayer);

                map.setView(view);

                map.render();
                setMapObj(map);
                setFirstLoad(false);

                /**
                 * Map events
                 */
                map.on("moveend", () => {
                    const extent = map.getView().calculateExtent()
                    setMapextent(extent);
                    sDispatch({ type: "setmapextent", payload: { mapextent: extent} });
                });

                map.on("postrender", () => {
                    //Displays the current map scale.
                    mapPostRender(map);
                });
            }.bind(this), 500); //
        }
    },[]);

    /**
     * Stores the view request if the extent has changed.
     */
    useEffect(() => {
        if (mapextent.length === 4){

            if (sState.isActive){
                if (sState.blayer !== 'aerial'){
                    const suggestedLayer = layerScaleCheck(getMapScale(mapObj), uState.company.companytype);
                    let currentLayer = '';
                    if (sState.blayer === 'osmm' || sState.blayer === 'osmmbw'){ currentLayer = 'osmm'; } else { currentLayer = sState.blayer; }
                    if (suggestedLayer !== currentLayer){
                        sDispatch({ type: "setBaseLayer", payload: { layer: suggestedLayer} });
                    }
                    recordView(mapObj, suggestedLayer, sState.dlayer, sState); //This needs to be adjusted as sState.blayer could be the previous layer if its changed.
                    setCopyright(suggestedLayer);
                } else {
                    recordView(mapObj, sState.blayer, sState.dlayer, sState); //This needs to be adjusted as sState.blayer could be the previous layer if its changed.
                    setCopyright(sState.blayer);
                }

            } else {
                if (getMapScale(mapObj) < 4000){
                    setViewScale(5000);
                    sDispatch({ type: "setBaseLayer", payload: { layer: 'open'} });
                }
            }
            setCurrentextent(mapextent);
            addWatermark();
        }
    },[mapextent]);


    /**
     * Displays or hide datalayers
     */
    useEffect(() => {

        if (!firstLoad){
            
            if (sState.dlayerChange.layer !== ''){
                let bfound = false;
                if (sState.dlayerChange.action === 'add'){
                    mapObj.getLayers().forEach(layer => {
                        if (layer && layer.get('name') === sState.dlayerChange.layer) {
                            bfound = true;
                        }
                    });
                    if (!bfound){
                        const datalayer = DataLayers(sState.dlayerChange.layer, sState.dlayerChange.geoserver);
                        mapObj.getLayers().insertAt(1, datalayer);
                    }
                }
                if (sState.dlayerChange.action === 'remove'){
                    mapObj.getLayers().forEach(layer => {
                        if (layer && layer.get('name') === sState.dlayerChange.layer) {
                            mapObj.removeLayer(layer);
                        }
                    });
                }
                //Update screen copyright notice.
                mapObj.render();
            }
        }
    },[sState.dlayerChange]);

    
    /**
     * Activated on view address change
     */
    useEffect(() => {
        if (!firstLoad){

            mapObj.getView().setCenter([parseInt(sState.address.value.x), parseInt(sState.address.value.y)]);
            let addressViewScale = 10000;
            switch (sState.address.value.type){
                case 'postcode':
                case 'address':
                    addressViewScale = 500;
                    if (uState.company.companytype == 'training') addressViewScale = 10000; // As training set scale to 10000.
                    break;
                default:
                    addressViewScale = 10000;
            }
            setScale(addressViewScale);
            const mapExtent = setMapScale(addressViewScale, mapObj);
            mapObj.getView().fit([mapExtent.xmin, mapExtent.ymin, mapExtent.xmax, mapExtent.ymax]);
            addMapPin(mapObj, parseInt(sState.address.value.x), parseInt(sState.address.value.y));
            //mapObj.render();
        }
    },[sState.address]);

    /**
     * Draws the map pin to mark the coordinates
    */
    const addMapPin = (map, posX, posY) => {

        const iconFeature = new Feature({
            geometry: new Point([posX,posY])
        });
        iconFeature.setId('mapPin');

        const svg = '<svg width="32" height="48" viewBox="0 0 32 48" xmlns="http://www.w3.org/2000/svg">'
        + '<path d="M16 0C7.604 0 0 6.806 0 15.204C0 23.6 6.938 33.624 16 48C25.062 33.624 32 23.6 32 15.204C32 6.806 24.398 0 16 0ZM16 22C12.686 22 10 19.314 10 16C10 12.686 12.686 10 16 10C19.314 10 22 12.686 22 16C22 19.314 19.314 22 16 22Z" fill="#DC3131"/>'
        + '</svg>';
        
        const style = new Style({
        image: new Icon({
            anchor:[0.5,1],
            opacity: 0.8,
            src: 'data:image/svg+xml,' + encodeURIComponent(svg),
            scale: 0.6
        })
        });

        if (hasPin){ map.removeLayer(mapPinLayer); setHasPin(false);}

        const pinLayer = new VectorLayer({
            source: new VectorSource({features: [iconFeature]}),
            style: style
        });

        setMapPinLayer(pinLayer);

        map.addLayer(pinLayer);
        setHasPin(true);
        //map.render();
    }

    /**
     * Draws the watermark
     */
    const setCopyright = (layer) => {

        if (layer === 'aerial'){
            setCopyrightNotice(process.env.REACT_APP_AERIAL_SCREENCOPY.replace("dddd", new Date().getFullYear()));
        } else {
            setCopyrightNotice(process.env.REACT_APP_OS_SCREENCOPY.replace("dddd", new Date().getFullYear()));
        }
    }

    /**
     * Draws the watermark
     */
    const addWatermark = () => {

        if (hasWatermarkLayer){
            watermarkLayer.setMap(null);
        }

        const watermark = new TileLayer({
            source: new TileImage({
                url: process.env.REACT_APP_WATERMARK_PATH,
                name: 'watermark'
            }),
            map: mapObj,
            opacity: process.env.REACT_APP_WATERMARK_OPACITY ? parseFloat(process.env.REACT_APP_WATERMARK_OPACITY) : 0.2
        });

        setWatermarkLayer(watermark);
        setHasWatermarkLayer(true);
    }


    const endMapInteraction = () => {
        mapObj.removeInteraction(mapSelect);
        mapObj.removeInteraction(mapTranslate);
        mapObj.removeInteraction(mapSnap);
    }

    /**
     * Activated on page size change
     */
    useEffect(() => {
        if (!firstLoad){
            mapObj.updateSize();
        }
    },[props.width, props.height]);


    /** Renders the newly selected basemap. **/
    useEffect(() => {
        if (!firstLoad && bLayer !== sState.blayer){
            if (currentBLayer !== null ){ mapObj.removeLayer(currentBLayer); }
            const baselayer = BaseLayers(sState.blayer, uState.company.companytype);
            setCurrentBLayer(baselayer);
            mapObj.getLayers().insertAt(0, baselayer);
            mapObj.renderSync()
        }
    },[sState.blayer]);


    /** Stores the view scale **/
    useEffect(() => {
        if (viewScale !== sState.viewScale){
            sDispatch({
                type: "setViewScale",
                payload: { viewScale: viewScale}
            });
        }
    },[viewScale]);
    
    var scaleTimer1;
    useEffect(() => {
        if (!firstLoad){
            clearTimeout(scaleTimer1);
            scaleTimer1 = setTimeout(function(){
                if (viewScale !== sState.viewScale){
                    const mapExtent = setMapScale(sState.viewScale, mapObj);
                    mapObj.getView().fit([mapExtent.xmin, mapExtent.ymin, mapExtent.xmax, mapExtent.ymax]);
                }
            }, 500); 


        }
    },[sState.viewScale]);
    

    var scaleTimer2;
    const mapPostRender = (map) => {
        if (typeof map !== 'undefined'){
            clearTimeout(scaleTimer2);
            scaleTimer2 = setTimeout(function(){
                if (viewScale !== sState.viewScale){
                    setViewScale(getMapScale(map));
                }
            }, 500); 
        }

    }

    /** Printing section **/

    /** Flag for the displaying of the print frame on map window. */
    useEffect(() => {
        if (sState.hasPrintFrame) { setDisplayPrintFrame(sState.hasPrintFrame); } else { }
    },[sState.hasPrintFrame]);


    useEffect(() => {

        if (displayPrintFrame){
            //Removes data window if exists
            if (hasDataWindow){ clearDataWindow(); }
            setPrint(sState.print)
            drawPrintWindow();
        }

    },[sState.print.layer,sState.print.size,sState.print.scale,sState.print.orientation,displayPrintFrame]);


    /**
     * Stores the print frame extent for pricing.
     */
    useEffect(() => {

        if (printFrame !== null){
            const extent = printFrame.getExtent();
            sDispatch({
                type: "setprintframe",
                payload: { extent: extent, area: printFrame.getArea()}
            });
        }
    },[printFrame]);


    /** Draws the print frame  **/
    const drawPrintWindow = () => {
        storeAnnotationLayer(); //stores any annotations / markups that have been drawn.

        //Get the details to calculated the window size.
        let ext = []; 
        if (hasPrintWindow){
            ext = printWindowLayer.getSource().getFeatureById('printGeom').getGeometry().getExtent();
        } else {
            ext = mapObj.getView().calculateExtent();
        }
        const cx = parseInt(ext[0]) + ((parseInt(ext[2]) - parseInt(ext[0]))/2);
        const cy = parseInt(ext[1]) + ((parseInt(ext[3]) - parseInt(ext[1]))/2);
        const templates = sState.templates;

        let pwidth = 0; 
        let pheight = 0;

        templates.forEach(function (t) {
            if (t.pagesize === sState.print.size && t.orientation === sState.print.orientation){
                pwidth = t.mapwidth;
                pheight = t.mapheight;
            }
        });
        const pw = getPrintWindowExt(parseInt(sState.print.scale), pwidth, pheight, cx, cy, props.width, props.height);
        
        const w = []
        w.push([pw.px1,pw.py1],[pw.px1,pw.py2],[pw.px2,pw.py2],[pw.px2,pw.py1],[pw.px1,pw.py1]);
        const poly = new Polygon([w]);
        const feature = new Feature({
            id: 'printGeom',
            geometry: poly
        })
        feature.setId('printGeom');
        if (poly.getArea() > 1){
            setPrintFrame(poly);
            const styles = [new Style({
                stroke: new Stroke({color: 'blue', width: 3}),
                fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})
            })];

            if (hasPrintWindow){
                mapObj.removeLayer(printWindowLayer);
            }

            //const vs = new VectorSource({features: [feature]});
            const printLayer = new VectorLayer({
                source: new VectorSource({features: [feature]}),
                style: styles
            });

            setPrintWindowLayer(printLayer);
            //mapobj.setLayerGroup(new LayerGroup);
            mapObj.addLayer(printLayer);
            mapObj.render();
            mapObj.getView().fit(poly, {
                size: mapObj.getSize(),
                padding: [50, 50, 50, 50],
            });
            setHasPrintWindow(true);
            startPrintWindow(feature, printLayer);
        }
    };

        /**
     * Starts the print window
     */
    const startPrintWindow = (feature, printLayer) => {
        
            setPrintWindowLoaded(true);

            const select = new Select({
                layers:[printLayer],
            });
            
            const translate = new Translate({
                features: select.getFeatures()
            });
            /*
            translate.on('translateend', function(e) {
                const features = e.features.getArray();
                const editedgeom = features[0].getGeometry();
                setPrintFrame(editedgeom);
            });
            */

            select.getFeatures().push(feature);
            mapObj.addInteraction(select);
            mapObj.addInteraction(translate);
            setMapSelect(select);
            setMapTranslate(translate);
    };

        /**
     * Ends the print window
     */
    const endPrintWindow = () => {
        if (hasPrintWindow){
            endMapInteraction();
            mapObj.removeLayer(printWindowLayer);
            setHasPrintWindow(false);
            setPrintWindowLoaded(false);
            setDisplayPrintFrame(false);
        }
    };

     /**************  Map Object Print End  **************/

    /**************  Map Object Data Starts  **************/

    /**
     * Display the data window.
     * Adjusts according to page variables and is entry point. i.e. aState.data changes
     */
    useEffect(() => {
        if(!firstLoad){
            if (hasPrintWindow){
                //Removes print window if exists
                mapObj.removeLayer(printWindowLayer);
                setHasPrintWindow(false);
                setPrintWindowLayer(null);
            }

            drawDataWindow();
        }
    },[sState.data]);

    const drawDataWindow = () => {

        if(!firstLoad){
            switch (sState.data.fixedsize){
                case '4ha':
                    drawDataFixed(200);
                    break;
                case '1ha':
                    drawDataFixed(100);
                    break;
                case 'custom':
                    // NOTE: no need to remove fixed area, can be edited or recreated
                    //if (hasDataWindow){ mapObj.removeLayer(dataWindowLayer); }
                    break;
                default:
                break;
            }
            
        }
    };
    var dataLayer;
    const drawDataFixed = (size) => {
        let ext = []; 
        mapObj.removeInteraction(mapTranslate);
        if (hasDataWindow){
            //Area already exists to get cx and cy from geom.
            // NOTE: area may not exist, e.g. if enabling custom drawing tool but not drawing area
            // TODO: debug that (but for now, add workaround)
            let feature = dataWindowLayer.getSource().getFeatureById('dataGeom');
            if (feature) {
                ext = feature.getGeometry().getExtent();
                //ext = dataWindowLayer.getSource().getExtent();
            }
            else {
                ext = mapObj.getView().calculateExtent();
            }
        } else {
            ext = mapObj.getView().calculateExtent();
        }
        const cx = parseInt(ext[0]) + ((parseInt(ext[2]) - parseInt(ext[0]))/2);
        const cy = parseInt(ext[1]) + ((parseInt(ext[3]) - parseInt(ext[1]))/2);

        const px1 = parseInt(cx - (size/2));
        const px2 = parseInt(cx + (size/2));
        const py1 = parseInt(cy - (size/2));
        const py2 = parseInt(cy + (size/2));

        const w = []
        w.push([px1,py1],[px1,py2],[px2,py2],[px2,py1],[px1,py1]);
        const poly = new Polygon([w]);
        const feature = new Feature({
            id: 'dataGeom',
            geometry: poly
        })
        feature.setId('dataGeom');
        if (poly.getArea() > 1){

            const styles = [new Style({
                stroke: new Stroke({color: 'blue', width: 3}),
                fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})
            })];

            if (hasDataWindow){ mapObj.removeLayer(dataWindowLayer); }

            //const dataLayer = new VectorLayer({
            dataLayer = new VectorLayer({
                source: new VectorSource({features: [feature]}),
                style: styles
            });

            setDataWindowLayer(dataLayer);
            mapObj.addLayer(dataLayer);
            mapObj.render();
            mapObj.getView().fit(poly, {
                size: mapObj.getSize(),
                padding: [50, 50, 50, 50],
            });
            setHasDataWindow(true);
            startDataWindow(feature, dataLayer);

            const geom = feature.getGeometry();
            const g = {
                geometry: geom.getCoordinates(),
                area: geom.getArea(),
            }
            sDispatch({ type: "setdatageom", payload: { datageom: g } });
        }
    };

    const drawDataRectangle = (sizeX, sizeY) => {

        mapObj.removeInteraction(mapTranslate);
        let ext = mapObj.getView().calculateExtent();
        const cx = parseInt(ext[0]) + ((parseInt(ext[2]) - parseInt(ext[0]))/2);
        const cy = parseInt(ext[1]) + ((parseInt(ext[3]) - parseInt(ext[1]))/2);

        const px1 = parseInt(cx - (sizeX/2));
        const px2 = parseInt(cx + (sizeX/2));
        const py1 = parseInt(cy - (sizeY/2));
        const py2 = parseInt(cy + (sizeY/2));

        const w = []
        w.push([px1,py1],[px1,py2],[px2,py2],[px2,py1],[px1,py1]);
        const poly = new Polygon([w]);
        const feature = new Feature({
            id: 'dataGeom',
            geometry: poly
        })
        feature.setId('dataGeom');
        if (poly.getArea() > 1){

            const styles = [new Style({
                stroke: new Stroke({color: 'blue', width: 3}),
                fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})
            })];

            if (hasDataWindow){ mapObj.removeLayer(dataWindowLayer); }

            //const dataLayer = new VectorLayer({
            dataLayer = new VectorLayer({
                source: new VectorSource({features: [feature]}),
                style: styles
            });

            setDataWindowLayer(dataLayer);
            mapObj.addLayer(dataLayer);
            mapObj.render();
            setHasDataWindow(true);
            startDataWindow(feature, dataLayer);

            const geom = feature.getGeometry();
            const g = {
                geometry: geom.getCoordinates(),
                area: geom.getArea(),
            }
            sDispatch({ type: "setdatageom", payload: { datageom: g } });
        }
    };

    const drawDataCoords = (x1, y1, x2, y2) => {

        const px1 = parseInt(x1);
        const px2 = parseInt(x2);
        const py1 = parseInt(y1);
        const py2 = parseInt(y2);

        const w = []
        w.push([px1,py1],[px1,py2],[px2,py2],[px2,py1],[px1,py1]);
        const poly = new Polygon([w]);
        const feature = new Feature({
            id: 'dataGeom',
            geometry: poly
        })
        feature.setId('dataGeom');
        if (poly.getArea() > 1){
            const styles = [new Style({
                stroke: new Stroke({color: 'blue', width: 3}),
                fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})
            })];

            if (hasDataWindow){ mapObj.removeLayer(dataWindowLayer); }

            //const dataLayer = new VectorLayer({
            dataLayer = new VectorLayer({
                source: new VectorSource({features: [feature]}),
                style: styles
            });

            setDataWindowLayer(dataLayer);
            mapObj.addLayer(dataLayer);

            //Checks to see if created geom is outside current view extent, if so zoom to geom.
            const mapext = mapObj.getView().calculateExtent();
            if (px1 < mapext[0] && py1 < mapext[1] && px2 > mapext[2] && py2 > mapext[3]){
                mapObj.getView().fit([px1-200, py1-200,  px2+200, py2+200]);   
            }

            mapObj.render();
            setHasDataWindow(true);
            startDataWindow(feature, dataLayer);

            const geom = feature.getGeometry();
            const g = {
                geometry: geom.getCoordinates(),
                area: geom.getArea(),
            }
            sDispatch({ type: "setdatageom", payload: { datageom: g } });
        }
    };

    const drawCustomDataRectangle = () => {
        resetMapInteractions();
        mapObj.removeInteraction(mapTranslate);

        if (hasDataWindow){
            setDataWindowLayer(null);
            mapObj.removeLayer(dataWindowLayer);
            setHasDataWindow(false);
        }

        const styles = [new Style({
            stroke: new Stroke({color: 'blue', width: 3}),
            fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})
        })];

            //const dataLayer = new VectorLayer({
        dataLayer = new VectorLayer({
            source: new VectorSource({wrapX: false}),
            style: styles
        });

        //mapobj.render();
        const draw = new Draw({
            source: dataLayer.getSource(),
            type: 'Circle',
            geometryFunction: createBox(),
        });

        draw.on('drawend', function(e) {
            e.feature.setProperties({
              'id': 'dataGeom',
              'shape': 'rectangle'
            });
        });
        setMapDraw(draw);
        mapObj.addInteraction(draw);

        dataLayer.getSource().on('addfeature', setIdDataRectangle);

        setDataWindowLayer(dataLayer);
        mapObj.addLayer(dataLayer);
        setHasDataWindow(true);

    }

    const drawCustomDataPolygon = () => {
        resetMapInteractions();
        //mapobj.removeInteraction(mapPan);
        mapObj.removeInteraction(mapTranslate);
        if (hasDataWindow){
            setDataWindowLayer(null);
            mapObj.removeLayer(dataWindowLayer);
            setHasDataWindow(false);
        }
        //mapobj.render();

        const styles = [new Style({
            stroke: new Stroke({color: 'blue', width: 3}),
            fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})
        })];

            //const dataLayer = new VectorLayer({
        dataLayer = new VectorLayer({
            source: new VectorSource({wrapX: false}),
            style: styles,
        });

        const draw = new Draw({
            source: dataLayer.getSource(),
            type: 'Polygon',
          });
    
        //draw.on('drawend', setDataDrawEndPolygon(draw));
        draw.on('drawend', function(e) {
            e.feature.setProperties({
              'id': 'dataGeom',
              'shape': 'polygon'
            });
        });
        setMapDraw(draw);
        mapObj.addInteraction(draw);

        dataLayer.getSource().on('addfeature', setIdDataPolygon);

        setDataWindowLayer(dataLayer);
        mapObj.addLayer(dataLayer);
        mapObj.render();
        setHasDataWindow(true);
        //startDataWindow(feature, dataLayer);
    }

    /**
     * Sets the id of the created polygon for data exports and stores.
     */
    const setIdDataPolygon = (event) => {

        //setFreezeaction(false);
        mapObj.getInteractions().pop();
        event.feature.setId('dataGeom');
        const geom = event.feature.getGeometry();
        storeCreatedArea(geom);
        startDataWindow(event.feature, dataLayer);
    }

    const setIdDataRectangle = (event) => {
        mapObj.getInteractions().pop()
        event.feature.setId('dataGeom');
        const geom = event.feature.getGeometry();

        const select = new Select({
            layers:[dataLayer],
            wrapX: false,
        });

        const translate = new Translate({
            features: select.getFeatures()
        });

        translate.on('translateend', function(e) {
            const features = e.features.getArray();
            const editedgeom = features[0].getGeometry();
            storeCreatedArea(editedgeom);
        });
        mapObj.addInteraction(translate);
          
        const modify = new Modify({
            features: select.getFeatures(),
        });

        //const snap = new Snap({source: dataWindowLayer.getSource()});
        // TODO: should this be setMapSelect ?
        setMapSnap(select);
        mapObj.addInteraction(select);

        const styles = [new Style({
            stroke: new Stroke({color: 'blue', width: 3}),
            fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})
        })];

        if (event.feature.get('shape') ==='rectangle'){

            //For handling rectangles
            var modifyingFeatures = [];
            var rectangleInteraction;
            modify.on('modifystart', function(e) {
                modifyingFeatures = e.features;
                var extent;
                const features = e.features.getArray();
                const editedgeom = features[0].getGeometry().getCoordinates();
                
                features[0].set('coordinates', editedgeom );

                extent = features[0].getGeometry().getExtent();
                document.addEventListener('pointermove', modifying);

                rectangleInteraction = new Extent({
                    boxStyle: styles 
                });
                rectangleInteraction.setActive(false);
                if (extent) {
                    rectangleInteraction.setExtent(extent); 
                }
                mapObj.addInteraction(rectangleInteraction);
            });

            var modifying = function(c){

                const features = modifyingFeatures.getArray();
                var oldCoordinates = features[0].get('coordinates');
                
                if (!oldCoordinates) {
                    return;
                }
                var newCoordinates = features[0].getGeometry().getCoordinates();
                if (typeof newCoordinates !== 'undefined' || typeof oldCoordinates !== 'undefined'){
                    var newExtent = getRectangleExtent(oldCoordinates, newCoordinates)
                    rectangleInteraction.setExtent(newExtent);
                }
            };
        }

        modify.on('modifyend', function(e) {

            document.removeEventListener('pointermove', modifying);
            const features = e.features.getArray();
            const editedgeom = features[0].getGeometry();
            var polygon = new Feature(fromExtent(rectangleInteraction.getExtent()));
            editedgeom.setCoordinates(polygon.getGeometry().getCoordinates());
            editedgeom.unset('coordinates');

            modifyingFeatures = [];
            mapObj.removeInteraction(rectangleInteraction);
            rectangleInteraction = null;

            storeCreatedArea(editedgeom);
        });

        mapObj.addInteraction(modify);
        setMapModify(modify);

        const snap = new Snap({features: select.getFeatures(), vertex: true});

        // TODO: clear up confusion with snap/select above as well
        mapObj.addInteraction(snap);

        storeCreatedArea(geom);
        startDataWindow(event.feature, dataLayer);

    }

    function getRectangleExtent(oldCoordinates, newCoordinates) {
        var result;
        if (oldCoordinates[0].length === newCoordinates[0].length) {

          let diffVertex = -1;
          for (let i = 0; i < oldCoordinates[0].length; i++) {
            if (oldCoordinates[0][i][0] !== newCoordinates[0][i][0] ||
                oldCoordinates[0][i][1] !== newCoordinates[0][i][1]) {
              diffVertex = i;
            }
          }

          let oppositeVertex = diffVertex > 1 ? diffVertex - 2 : diffVertex + 2;

          if (typeof newCoordinates[0][diffVertex] !== 'undefined'){
            let minX = Math.min(newCoordinates[0][diffVertex][0], newCoordinates[0][oppositeVertex][0]);
            let minY = Math.min(newCoordinates[0][diffVertex][1], newCoordinates[0][oppositeVertex][1]);
            let maxX = Math.max(newCoordinates[0][diffVertex][0], newCoordinates[0][oppositeVertex][0]);
            let maxY = Math.max(newCoordinates[0][diffVertex][1], newCoordinates[0][oppositeVertex][1]);
            result = [minX, minY, maxX, maxY];
          }


        } else {

          let newVertex;
          let i;
          newCo:for (i = 0; i < newCoordinates[0].length; i++) {
            for (let j = 0; j < oldCoordinates[0].length; j++) {
              if (newCoordinates[0][i][0] === oldCoordinates[0][j][0]) {
                if (newCoordinates[0][i][1] === oldCoordinates[0][j][1]) {
                  continue newCo;
                }
              }
            }

            newVertex = i
            break;
          }
          if (!newVertex) {
            result = boundingExtent(oldCoordinates[0]);
            return result;
          }
          let oppositeVertex1 = i - 2 > 0 ? i - 2 : i + 3;
          let oppositeVertex2 = i - 3 > 0 ? i - 3 : i + 2;
          result = boundingExtent([
            newCoordinates[0][newVertex],
            newCoordinates[0][oppositeVertex1],
            newCoordinates[0][oppositeVertex2]
          ]);
 
        }
        return result;
      }


    const storeCreatedArea = (geom) => {

        const g = {
            geometry: geom.getCoordinates(),
            area: geom.getArea(),
        }

        sDispatch({
            type: "setdatageom",
            payload: { datageom: g }
        });
    }

    /**
     * Allows for object selection and object drag.
     */
    const startDataEditMode = () => {

        resetMapInteractions();

        const select = new Select({
            layers:[dataWindowLayer],
            wrapX: false,
        });

        // Auto-select geometry
        let features = dataWindowLayer.getSource().getFeatures();
        if (features.length > 0) {
            let feature = features.pop();
            select.getFeatures().push(feature);
        }

        setMapSelect(select);
        const translate = new Translate({
            features: select.getFeatures()
        });

        translate.on('translateend', function(e) {
            const features = e.features.getArray();
            const editedgeom = features[0].getGeometry();
            storeCreatedArea(editedgeom);
        });
    
        const modify = new Modify({
            features: select.getFeatures(),
        });
        
        modify.on('modifyend', function(e) {
            const features = e.features.getArray();
            const editedgeom = features[0].getGeometry();
            storeCreatedArea(editedgeom);
        });
        setMapModify(modify);

        mapObj.addInteraction(select);
        mapObj.addInteraction(translate);
        mapObj.addInteraction(modify);
        
    };


    /**
     * Allows for object selection and object drag.
     */
    const startDataWindow = (feature, dataLayer) => {

        resetMapInteractions();

        const select = new Select({
            layers:[dataLayer]
        });
        //
        const translate = new Translate({
            features: select.getFeatures()
        });

        translate.on('translateend', function(e) {
            const features = e.features.getArray();
            const editedgeom = features[0].getGeometry();
            storeCreatedArea(editedgeom);
        });

        // Auto-select geometry
        select.getFeatures().push(feature);

        mapObj.addInteraction(select);
        mapObj.addInteraction(translate);
        setMapSelect(select);
        setMapTranslate(translate);
        //storeDataPolygon(dataWindowLayer);
    };

    const storeDataPolygon = (layer) => {
        const geom = layer.getSource().getFeatureById('dataGeom').getGeometry();
        const g = {
            geometry: geom.getCoordinates(),
            area: geom.getArea(),
        }
        sDispatch({
            type: "setdatageom",
            payload: { datageom: g }
        });
    }

    const resetMapInteractions = () => {
        clearMapInteractions();
        addDefaultMapInteractions();
    }

    const clearMapInteractions = () => {
        if (mapObj !== null){
            //if (mapSelect !== null){ mapSelect.getFeatures().clear(); }

            mapObj.getInteractions().forEach((interaction) => {
                // NOTE: interaction names are available in dev but not in prod build
                mapObj.getInteractions().pop();
            });
        }
    }

    const addDefaultMapInteractions = () => {
        if (mapObj !== null) {
            // TODO: simply re-add all the defaults to include touch controls etc?
            const p = new DragPan();
            mapObj.addInteraction(p);
            const z = new MouseWheelZoom();
            mapObj.addInteraction(z);
            const dcz = new DoubleClickZoom();
            mapObj.addInteraction(dcz);
        }
    }

    const clearDataWindow = () => {
        if (hasDataWindow){
            setDataWindowLayer(null);
            mapObj.removeLayer(dataWindowLayer);
            setHasDataWindow(false);

            sDispatch({type: "setdatageom", payload: { datageom: { geometry: 0, area: 0 } }});

            addDefaultMapInteractions();
        }
    }

    /**************  Map Object Data Ends  **************/

    /**************  Map Object Reports Start  **************/

    useEffect(() => {
        if(!firstLoad){
            if (hasPrintWindow){
                //Removes print window if exists
                mapObj.removeLayer(printWindowLayer);
                setHasPrintWindow(false);
                setPrintWindowLayer(null);
            }
            if (hasDataWindow){
                //Removes print window if exists
                mapObj.removeLayer(dataWindowLayer);
                setHasDataWindow(false);
                setDataWindowLayer(null);
            }

            drawReportWindow();
        }
    },[sState.report]);

    const drawReportWindow = () => {

        if(!firstLoad){
            switch (sState.report.fixedsize){
                case '4ha':
                    drawReportFixed(200);
                    break;
                case '1ha':
                    drawReportFixed(100);
                    break;
                case '10ha':
                    drawReportFixed(316);
                    break;
                case '15ha':
                    drawReportFixed(387);
                    break;
                case 'custom':
                    if (hasReportWindow){ mapObj.removeLayer(reportWindowLayer); }
                    break;
                default:
                break;
            }
            
        }
    };

    const drawReportFixed = (size) => {

        mapObj.removeInteraction(mapTranslate);
        const ext = mapObj.getView().calculateExtent();

        const cx = parseInt(ext[0]) + ((parseInt(ext[2]) - parseInt(ext[0]))/2);
        const cy = parseInt(ext[1]) + ((parseInt(ext[3]) - parseInt(ext[1]))/2);

        const px1 = parseInt(cx - (size/2));
        const px2 = parseInt(cx + (size/2));
        const py1 = parseInt(cy - (size/2));
        const py2 = parseInt(cy + (size/2));

        const w = []
        w.push([px1,py1],[px1,py2],[px2,py2],[px2,py1],[px1,py1]);
        const poly = new Polygon([w]);
        const feature = new Feature({
            id: 'reportGeom',
            geometry: poly
        })
        feature.setId('reportGeom');
        if (poly.getArea() > 1){

            const styles = [new Style({
                stroke: new Stroke({color: 'blue', width: 3}),
                fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})
            })];

            if (hasReportWindow){ mapObj.removeLayer(reportWindowLayer); }

            const reportLayer = new VectorLayer({
                source: new VectorSource({features: [feature]}),
                style: styles
            });

            setReportWindowLayer(reportLayer);
            mapObj.addLayer(reportLayer);
            mapObj.render();
            setHasReportWindow(true);
            startReportWindow(reportLayer);

            const geom = feature.getGeometry();
            storeReportArea(geom);
        }
    };

    const drawReportRectangle = (sizeX, sizeY) => {

        mapObj.removeInteraction(mapTranslate);
        const ext = mapObj.getView().calculateExtent();
        const cx = parseInt(ext[0]) + ((parseInt(ext[2]) - parseInt(ext[0]))/2);
        const cy = parseInt(ext[1]) + ((parseInt(ext[3]) - parseInt(ext[1]))/2);

        const px1 = parseInt(cx - (sizeX/2));
        const px2 = parseInt(cx + (sizeX/2));
        const py1 = parseInt(cy - (sizeY/2));
        const py2 = parseInt(cy + (sizeY/2));

        const w = []
        w.push([px1,py1],[px1,py2],[px2,py2],[px2,py1],[px1,py1]);
        const poly = new Polygon([w]);
        const feature = new Feature({
            id: 'reportGeom',
            geometry: poly
        })
        feature.setId('reportGeom');
        if (poly.getArea() > 1){
            const styles = [new Style({
                stroke: new Stroke({color: 'blue', width: 3}),
                fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})
            })];

            if (hasReportWindow){ mapObj.removeLayer(reportWindowLayer); }

            const reportLayer = new VectorLayer({
                source: new VectorSource({features: [feature]}),
                style: styles
            });

            setDataWindowLayer(reportLayer);
            mapObj.addLayer(reportLayer);
            mapObj.render();
            setHasDataWindow(true);
            startDataWindow(feature, reportLayer);

            const geom = feature.getGeometry();
            storeReportArea(geom);
        }
    };

    const startReportWindow = (dataLayer) => {

        resetMapInteractions();

        const select = new Select({
            layers:[dataLayer]
        });
        //
        const translate = new Translate({
            features: select.getFeatures()
        });

        translate.on('translateend', function(e) {
            const features = e.features.getArray();
            const editedgeom = features[0].getGeometry();
            storeReportArea(editedgeom);
        });

        mapObj.addInteraction(select);
        mapObj.addInteraction(translate);
        setMapSelect(select);
        setMapTranslate(translate);
        //storeDataPolygon(dataWindowLayer);
    };

    const storeReportArea = (geom) => {

        const g = {
            geometry: geom.getCoordinates(),
            area: geom.getArea(),
        }

        sDispatch({
            type: "setreportgeom",
            payload: { reportgeom: g }
        });
    }

            /**
     * Ends the print window
     */
    const endReportWindow = () => {
        if (hasReportWindow){

            endMapInteraction();
            mapObj.removeLayer(reportWindowLayer);
            setHasReportWindow(false);
        }
    };

    /**************  Map Object Report Ends  **************/

    /**************  Map Object Annotations Start  **************/

    const selectedVertexStyle = new Style({
        image: new Circle({
          radius: 6,
          fill: new Fill({
            color: 'rgb(229,83,0)'
          })
        }),
        geometry: function(feature) {
          // return the coordinates of the first ring of the polygon
          let coordinates = feature.getGeometry().getCoordinates()[0];
          return new MultiPoint(coordinates);
        }
      })
    /**
     * Listens for colour change
     */
    useEffect(() => {

        if (typeof sState.annotationStyle.outline !== 'undefined'){

            setStrokeColour(sState.annotationStyle.outline.colour);
            setStrokeWidth(sState.annotationStyle.outline.width);

            if (mapSelect !== null){
                const selectedObject = mapSelect.getFeatures();
                
                if (selectedObject.getLength() > 0){
                    let lineColour = sState.annotationStyle.outline.colour;
                    let lineWidth = sState.annotationStyle.outline.width;
                    let fillColour = sState.annotationStyle.fill.colour;

                    const selectStyle = [
                        new Style({
                            stroke: new Stroke({
                              color: lineColour,
                              width: lineWidth,
                            }),
                            fill: new Fill({
                              color: fillColour,
                            }),
                        }),
                        selectedVertexStyle,
                    ];
                    if (selectedObject.item(0).get('shape') !== 'text'){
                        selectedObject.item(0).setStyle(selectStyle);
                        storeAnnotationLayer();
                    }

                }
            }

        }
    },[sState.annotationStyle.outline.colour, sState.annotationStyle.outline.width, sState.annotationStyle.fill.colour]);

    /**
     * Listerns for textbox changes.
    */
     useEffect(() => {

        if (typeof sState.textAnnotation.text !== 'undefined' && sState.textAnnotation.source === 'menu'){

            if (mapSelect !== null){
                const selectedObject = mapSelect.getFeatures();
                
                if (selectedObject.getLength() > 0){
                    let lineColour = sState.textAnnotation.outline.colour;
                    let lineWidth = sState.textAnnotation.outline.width;
                    let fillColour = sState.textAnnotation.fill.colour;
                    let textFont = sState.textAnnotation.font;
                    let textText = sState.textAnnotation.text;

                    const selectStyle = [
                        new Style({
                            fill: new Fill({color: fillColour}),
                            stroke: new Stroke({color: lineColour, width: lineWidth}),
                            text: new Text({text:textText, font:textFont})
                        }),
                        selectedVertexStyle,
                    ];

                    if (selectedObject.item(0).get('shape') === 'text'){
                        selectedObject.item(0).setStyle(selectStyle);
                        storeAnnotationLayer();
                    }

                }
            }
        }
    },[sState.textAnnotation.text, sState.textAnnotation.font]);

    /**
     * Listerns for measurement unit changes.
    */
     useEffect(() => {
        setAnnotationUnits(sState.measurementUnits);
    },[sState.measurementUnits.area, sState.measurementUnits.length]);


    /**
     * function that handles the selection of map annotations.
     */
    const selectAnnotationObject = () => {

        if (hasAnnotationLayer){
            let annoType = 'none';
            resetMapInteractions();
    
            const select = new Select({
                layers:[annotationLayer],
                style: null
            });

            select.on('select', function(e) {
                if (typeof e.selected[0] !== 'undefined'){ 
                    var selectStyle = [];
                    const cStyle = e.selected[0].getStyle();

                    if (e.selected[0].get('shape') === 'polygon'){
                        annoType = 'polygon';
                        selectStyle = [
                            new Style({
                                stroke: new Stroke({
                                color: cStyle[0].stroke_.color_,
                                width: cStyle[0].stroke_.width_,
                                }),
                                fill: new Fill({
                                color: cStyle[0].fill_.color_,
                                }),
                            }),
                            selectedVertexStyle,
                        ];
                        e.selected[0].setStyle(selectStyle);

                        const s = sState.annotationStyle;
                        s.outline.colour = cStyle[0].stroke_.color_;
                        s.outline.width = cStyle[0].stroke_.width_;
                        s.fill.colour = cStyle[0].fill_.color_;
                        sDispatch({type: "setstyle", payload: { style: s }});

                        setAnnotationArea(e.selected[0].getGeometry().getArea());
                    }
                    if (e.selected[0].get('shape') === 'text'){
                        annoType = 'text';
                        selectStyle = [
                            new Style({
                                fill: new Fill({color: cStyle[0].fill_.color_}),
                                stroke: new Stroke({color: cStyle[0].stroke_.color_, width: cStyle[0].stroke_.width_}),
                                text: new Text({text:cStyle[0].text_.text_, font:cStyle[0].text_.font_})
                            }),
                            selectedVertexStyle,
                        ];
                        const currentAnnotation = sState.textAnnotation;
                        currentAnnotation.text = cStyle[0].text_.text_;
                        currentAnnotation.font = cStyle[0].text_.font_;
                        currentAnnotation.source = 'mapping';
                        sDispatch({ type: "settextannotation", payload: { annotations: currentAnnotation } });

                        e.selected[0].setStyle(selectStyle);
                    }
                }

                sDispatch({ type: "annotationselected", payload: { type: annoType } });
                if (typeof e.deselected[0] !== 'undefined'){
                    const cStyle = e.deselected[0].getStyle();
                    if (e.deselected[0].get('shape') === 'polygon'){
                        selectStyle = [
                            new Style({
                                stroke: new Stroke({
                                color: cStyle[0].stroke_.color_,
                                width: cStyle[0].stroke_.width_,
                                }),
                                fill: new Fill({
                                color: cStyle[0].fill_.color_,
                                }),
                            }),
                        ];
                    }
                    if (e.deselected[0].get('shape') === 'text'){
                        selectStyle = [
                            new Style({
                                fill: new Fill({color: cStyle[0].fill_.color_}),
                                stroke: new Stroke({color: cStyle[0].stroke_.color_, width: cStyle[0].stroke_.width_}),
                                text: new Text({text:cStyle[0].text_.text_, font:cStyle[0].text_.font_})
                            }),
                        ];
                    }
                    e.deselected[0].setStyle(selectStyle);
                }
                
            });
              
            const translate = new Translate({
                features: select.getFeatures()
            });
    
            mapObj.addInteraction(translate);

            const modify = new Modify({
                features: select.getFeatures(),
            });
            setMapSelect(select);
            mapObj.addInteraction(select);

            //For handling rectangles
            var modifyingFeatures = [];
            var rectangleInteraction;
            modify.on('modifystart', function(e) {
                modifyingFeatures = e.features;
                var extent;
                const features = e.features.getArray();
                const editedgeom = features[0].getGeometry().getCoordinates();
                if (features[0].get('shape') ==='text'){

                    const cStyle = features[0].getStyle();
                    features[0].set('coordinates', editedgeom );
                    extent = features[0].getGeometry().getExtent();
                    document.addEventListener('pointermove', modifying);
    
                    const styles = [
                        new Style({
                            fill: new Fill({color: cStyle[0].fill_.color_}),
                            stroke: new Stroke({color: cStyle[0].stroke_.color_, width: cStyle[0].stroke_.width_}),
                            text: new Text({text:cStyle[0].text_.text_, font:cStyle[0].text_.font_})
                        }),
                    ];
                    rectangleInteraction = new Extent({
                        boxStyle: styles 
                    });
                    rectangleInteraction.setActive(false);

                    if (extent) {
                        rectangleInteraction.setExtent(extent); 
                    }
                    mapObj.addInteraction(rectangleInteraction);
                }
            });
    
            var modifying = function(c){

                const features = modifyingFeatures.getArray();
                var oldCoordinates = features[0].get('coordinates');

                if (!oldCoordinates) {
                    return;
                }
                var newCoordinates = features[0].getGeometry().getCoordinates();
                if (typeof newCoordinates !== 'undefined' || typeof oldCoordinates !== 'undefined'){
                    var newExtent = getRectangleExtent(oldCoordinates, newCoordinates)
                    rectangleInteraction.setExtent(newExtent);
                }
            };
            
            modify.on('modifyend', function(e) {

                const features = e.features.getArray();
                const editedgeom = features[0].getGeometry();

                if (features[0].get('shape') ==='text'){
                    document.removeEventListener('pointermove', modifying);
                    var polygon = new Feature(fromExtent(rectangleInteraction.getExtent()));
                    editedgeom.setCoordinates(polygon.getGeometry().getCoordinates());
                    editedgeom.unset('coordinates');
                    modifyingFeatures = [];
                    mapObj.removeInteraction(rectangleInteraction);
                    rectangleInteraction = null;
                }
                if (features[0].get('shape') === 'polygon'){
                    setAnnotationArea(editedgeom.getArea());
                }
                storeAnnotationLayer();
            });
            
            //const modify = new Modify({source: dataWindowLayer.getSource()});
            mapObj.addInteraction(modify);
            setMapModify(modify);
    
            const snap = new Snap({features: select.getFeatures(), vertex: true});
            mapObj.addInteraction(snap);
            setMapSnap(snap);
        }
    }

    
    const drawAnnotationPolygon = () => {
   
        mapObj.removeInteraction(mapTranslate);
        let annoLayer = null;
        if (!hasAnnotationLayer){
            annoLayer = new VectorLayer({
                source: new VectorSource({wrapX: false}),
                style: null
            });
            
            setAnnotationLayer(annoLayer);
            setHasAnnotationLayer(true);
            mapObj.addLayer(annoLayer);
        } else {
            annoLayer = annotationLayer;
        }

        let lineColour = sState.annotationStyle.outline.colour;
        let lineWidth = sState.annotationStyle.outline.width;
        let fillColour = sState.annotationStyle.fill.colour;

        const styles = [new Style({
            stroke: new Stroke({color: lineColour, width: lineWidth}),
            fill: new Fill({color: fillColour})
        })];

        const draw = new Draw({
            source: annoLayer.getSource(),
            type: 'Polygon',
            style: styles
          });
        
        draw.on('drawstart',function(e){
            
            let lineColour = sState.annotationStyle.outline.colour;
            let lineWidth = sState.annotationStyle.outline.width;
            let fillColour = sState.annotationStyle.fill.colour;

            const styles = [new Style({
                stroke: new Stroke({color: lineColour, width: lineWidth}),
                fill: new Fill({color: fillColour})
            })];

            e.feature.setStyle(styles);
        });

        //draw.on('drawend', setDataDrawEndPolygon(draw));
        draw.on('drawend', function(e) {
            e.feature.setProperties({
              'shape': 'polygon'
            });
            storeAnnotationLayer();
        });
        setMapDraw(draw);
        mapObj.addInteraction(draw);
    }

    /**
     * Listens for unit measurement change
     */
     useEffect(() => {

        if (mapSelect !== null){

            const selectedObject = mapSelect.getFeatures();
            if (selectedObject.getLength() > 0){
                const randomDigits = Math.floor(Math.random() * 1000) / 10000000000;
                setAnnotationArea(selectedObject.item(0).getGeometry().getArea()+randomDigits);
            }
        }
    },[annotationUnits]);

    useEffect(() => {
        var output = 0;
        const selectedArea = Math.round(annotationArea * 1000) / 1000;
        const unit = annotationUnits.area;
        switch (unit){
            case "m":
                output = Math.round(selectedArea * 100) / 100+'m&sup2';
            break;
            case "km":
                output = Math.round((selectedArea / 1000000) * 100) / 100+'km&sup2';
            break;
            case "acre":
                output = Math.round((selectedArea / 4047) * 100) / 100+' acre';
            break;
            case "feet":
                output = Math.round((selectedArea * 10.764) * 100) / 100+'ft&sup2';
            break;
            default:
            case "ha":
                output = Math.round((selectedArea / 10000) * 100) / 100+'ha';
            break;
        }

        document.getElementById('txtLengthMeasurement').innerHTML = ' - ';
        document.getElementById('txtAreaMeasurement').innerHTML = output;  
    },[annotationArea]);

    useEffect(() => {
        var output = 0;
        let selectedLength = Math.round(annotationLength * 100) / 100;
        const unit = annotationUnits.length;
        switch (unit){
            default:
            case "m":
                output = Math.round(selectedLength * 100) / 100+'m';
            break;
            case "feet":
                output = Math.round((selectedLength * 3.281) * 100) / 100+'ft';
            break;
            case "km":
                output = Math.round((selectedLength / 1000 ) * 100) / 100+'km';
            break;
            case "mile":
                output = Math.round((selectedLength / 4047) * 100) / 100+' miles';
            break;
        }
        document.getElementById('txtAreaMeasurement').innerHTML = ' - ';
        document.getElementById('txtLengthMeasurement').innerHTML = output; 
    },[annotationLength]);

    const drawAnnotationText = () => {
   
        mapObj.removeInteraction(mapTranslate);
        let annoLayer = null;
        if (!hasAnnotationLayer){
            annoLayer = new VectorLayer({
                source: new VectorSource({wrapX: false}),
                style: null
            });
            
            setAnnotationLayer(annoLayer);
            setHasAnnotationLayer(true);
            mapObj.addLayer(annoLayer);
        } else {
            annoLayer = annotationLayer;
        }

        const draw = new Draw({
            source: annoLayer.getSource(),
            type: 'Circle',
            geometryFunction: createBox(),
            //style: styleAnnotationText()
        });

        
        let lineColour = sState.textAnnotation.outline.colour;
        let lineWidth = sState.textAnnotation.outline.width;
        let fillColour = sState.textAnnotation.fill.colour;
        const fontStyle = sState.textAnnotation.font;
        let fontText = sState.textAnnotation.text;

        const styles= [new Style({
            stroke: new Stroke({color: lineColour, width: lineWidth}),
            fill: new Fill({color: fillColour}),
            text: new Text({text:fontText, font:fontStyle})
        })];
        

        //style: styles
        draw.on('drawstart',function(e){
            
            e.feature.setStyle(styles);
            //e.feature.setStyle(styleAnnotationText());
            
        });

        //draw.on('drawend', setDataDrawEndPolygon(draw));
        draw.on('drawend', function(e) {
            e.feature.setProperties({
              'shape': 'text'
            });
            e.feature.setStyle(styles);
            //e.feature.setStyle(styleAnnotationText());


            const select = new Select({
                layers:[annotationLayer],
                style: null
            });
            select.getFeatures().push(e.feature);
            storeAnnotationLayer();
            mapObj.addInteraction(select);

        });

        setMapDraw(draw);
        mapObj.addInteraction(draw);
    }


    /**
     * Removes the current selected annotation
     */
    const removeAnnotation = () => {
        try {
            if (mapSelect !== null && hasAnnotationLayer){
                const selectedObject = mapSelect.getFeatures();
                if (selectedObject.getLength() > 0){
                    annotationLayer.getSource().removeFeature(selectedObject.item(0));
                    mapObj.render();
                }
            }
        } catch (error) {
            console.error(error);
        }

    }
    const removeAllAnnotation = () => {

        if (hasAnnotationLayer){
            mapObj.removeLayer(annotationLayer);
            mapObj.render();
            setAnnotationLayer(null);
            setHasAnnotationLayer(false);
        }
    }

    /**
     * Listerner for items to be drawn from fillPolygon click listerner
     */
    useEffect(() => {
        if (clickListerner !== null){
            let annoLayer = null;
            if (!hasAnnotationLayer){
                annoLayer = new VectorLayer({
                    source: new VectorSource({wrapX: false}),
                    style: null
                });
                setAnnotationLayer(annoLayer);
                setHasAnnotationLayer(true);
                mapObj.addLayer(annoLayer);
            } else {
                annoLayer = annotationLayer;
            }

            let lineColour = sState.annotationStyle.outline.colour;
            let lineWidth = sState.annotationStyle.outline.width;
            let fillColour = sState.annotationStyle.fill.colour;

            const styles = [new Style({
                stroke: new Stroke({color: lineColour, width: lineWidth}),
                fill: new Fill({color: fillColour})
            })];

            const wkt_geom = sState.dbAnnotation.geometry;
            setFillGeom(wkt_geom);
            if (doUnion && hasAnnotationLayer){
                //Removes last drawn feature
                var features = annoLayer.getSource().getFeatures();
                var lastFeature = features[features.length - 1];
                annoLayer.getSource().removeFeature(lastFeature);
            }

            const feature = new WKT().readFeature(sState.dbAnnotation.geometry);
            feature.setStyle(styles);
            feature.set('shape', 'polygon');

            annoLayer.getSource().addFeature(feature);
            mapObj.render();

            //Stores the geometry area for displaying
            setAnnotationArea(feature.getGeometry().getArea());

        }
    },[sState.dbAnnotation.geometry]);

    /**
     * Saves the raw features on the annotation layer.
     */
    const storeAnnotationLayer = () => {
        if (hasAnnotationLayer){
            const source = annotationLayer.getSource();
            const features = source.getFeatures();

            const annotations = [];
            features.forEach((item) => {
                let itemStyle = item.getStyle();
                let itemGeom = item.getGeometry();

                let a = {};
                a.type = item.get('shape');
                a.fill = itemStyle[0].fill_;
                a.stroke = itemStyle[0].stroke_;
                a.text = itemStyle[0].text_;
                a.extent = itemGeom.extent_;
                a.coordinates = itemGeom.orientedFlatCoordinates_;
                annotations.push(a);
            });
            if (annotations.length > 0 ){
                sDispatch({type: "setmapannotation", payload: { annotations: annotations }});
            }
        }
    }

    /**************  Map Object Annotations Ends  **************/

    /**************  Map Object Measurement tools Start  **************/

    //const [measurementLayer, setMeasurementLayer] = useState(null);
    //const [hasMeasurementLayer, setHasMeasurementLayer] = useState(false);

    const drawMeasureLine = () => {
   
        mapObj.removeInteraction(mapTranslate);
        let measureLayer = null;
        if (!hasMeasurementLayer){
            measureLayer = new VectorLayer({
                source: new VectorSource({wrapX: false}),
                style: null
            });
            
            setMeasurementLayer(measureLayer);
            setHasMeasurementLayer(true);
            mapObj.addLayer(measureLayer);
        } else {
            measureLayer = measurementLayer;
        }

        const styles = [new Style({
            stroke: new Stroke({color: 'rgba(0, 0, 0, 0.5)', lineDash: [10, 10], width: 4}),
            fill: new Fill({color: 'rgba(255, 255, 255, 0.2)'}),
            image: new Circle({adius: 5, stroke: new Stroke({color: 'rgba(0, 0, 0, 0.7)'}), fill: new Fill({color: 'rgba(255, 255, 255, 0.2)'}),})
        })];

        const draw = new Draw({
            source: measureLayer.getSource(),
            type: 'LineString',
            style: styles
          });
        
        draw.on('drawstart',function(e){
            const sketch = e.feature;

            let listener = sketch.getGeometry().on('change', function(evt) {
              setAnnotationLength(sketch.getGeometry().getLength())
            });
        }, this);

        draw.on('drawend', function(e) {
            const s = sState.annotationStyle;
            s.length = 0;
            sDispatch({type: "setstyle", payload: { style: s }});
            mapObj.removeLayer(measureLayer);
        });

        setMapDraw(draw);
        mapObj.addInteraction(draw);
    }

    const drawMeasureArea = () => {
   
        mapObj.removeInteraction(mapTranslate);
        let measureLayer = null;
        if (!hasMeasurementLayer){
            measureLayer = new VectorLayer({
                source: new VectorSource({wrapX: false}),
                style: null
            });
            
            setMeasurementLayer(measureLayer);
            setHasMeasurementLayer(true);
            mapObj.addLayer(measureLayer);
        } else {
            measureLayer = measurementLayer;
        }

        const styles = [new Style({
            stroke: new Stroke({color: 'rgba(0, 0, 0, 0.5)', lineDash: [10, 10], width: 4}),
            fill: new Fill({color: 'rgba(255, 255, 255, 0.2)'}),
            image: new Circle({adius: 5, stroke: new Stroke({color: 'rgba(0, 0, 0, 0.7)'}), fill: new Fill({color: 'rgba(255, 255, 255, 0.2)'}),})
        })];

        const draw = new Draw({
            source: measureLayer.getSource(),
            type: 'Polygon',
            style: styles
          });
        
        draw.on('drawstart',function(e){
            const sketch = e.feature;

            let listener = sketch.getGeometry().on('change', function(evt) {
              setAnnotationArea(sketch.getGeometry().getArea());
            });
        }, this);

        draw.on('drawend', function(e) {
            mapObj.removeLayer(measureLayer);
        });

        setMapDraw(draw);
        mapObj.addInteraction(draw);
    }

    /**************  For handling credit reached  **************/

    const [errorMsg, setErrorMsg] = useState('');
    const [severity, setSeverity] = useState('error');
    const [msg, setMsg] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);

    useEffect(() => {

        if (sState.creditReached){
            setSeverity('error')
            setMsg('We couldn’t complete your order as it exceeds your available credit limit. Please reach out to us on support@mapdata.uk, if you’d like help moving forward.')
            setSnackOpen(true);
        } else {
            setSnackOpen(false);
        }
    },[sState.creditReached]);

    const handleSnackClose=()=>{
        setSnackOpen(false);
        sDispatch({ type: 'creditReached', payload: { creditReached: false } });
        sDispatch({ type: 'setUserAction', payload: { action: 'creditReached' } });
    } 

    /**************  Map Object Measurement tools End  **************/

    return (
    <div className={classes.root}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackOpen} autoHideDuration={30000} onClose={handleSnackClose}>
            <Alert onClose={handleSnackClose} severity={severity}>
                {msg}
            </Alert>
        </Snackbar>
        <div id='map' className={classes.mapstyle} ></div>
        <div className={classes.copyrightLabel}>{copyrightNotice}</div> 
    </div>
    )
  }

